<template>
    <compatibility-features
        v-if="activeBuild.cpu"
        :active-build="activeBuild"
        :show-header="true"
        div-class="build-includes"
    />
</template>

<script>
import CompatibilityFeatures from "@c/store/build/step-4/components/compatibility-icons/features";

export default {
    name: "BuildIncludes",
    components: {
        CompatibilityFeatures
    },
    props: {
        activeBuild: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
@import '~@s/_asset-mixers.scss';

.build-includes {
    margin-top: 25px;

    @media (max-width: 768px) {
        padding: 0
    }

    &__heading {
        margin-top: 0;
        margin-bottom: 30px;
        color: $white;
        font-size: 16px;
        line-height: 24px;
    }

    &__features {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        @media (max-width: 768px) {
            padding-left: 5px;
        }
    }

    &__feature {
        width: 80px;
        height: 80px;
        text-align: center;
        display: flex;
        flex-direction: column;
        margin-bottom: 25px;

        @media (min-width: 991px) and (max-width: 1200px) {
            width: 75px;
        }

        &.not-active {
            opacity: 0.2;
        }

        &__name {
            color: $white;
            font-size: 14px;
            line-height: 17px;
        }

        &__icon {
            height: 32px;
            display: flex;
            justify-content: center;

            img {
                max-width: 32px;
            }
        }
    }
}
</style>
